export default {"src":"https://cdn.jetlend.ru/_next/static/media/top--badge.eb5777d6.svg","height":102,"width":80,"blurWidth":0,"blurHeight":0};